import requestModule from '../libs/requestModule'
import CartController from '../controllers/CartController'
import Util from '@/assets/libs/util.js'
import moment from 'moment'

const cashbackCampaignParams = {
    apiUrl: Util.getLocalConfigs('olgaTech')
}
// 'https://danielfonseca.zeedhi.com/workfolder/olga-tech/backend/service/index.php'
const apiHeaders = {
    'Authorization': 'Bearer W3gdc803j3dbxw3hedKB67312ls783HSecd6d84kJF303jceo3GEdpjUW902jUEw89xwge0Tk'
}

const GIFTSQRCODE = cashbackCampaignParams.apiUrl + '/giftsqrcode'
const GIFTVALIDADE = cashbackCampaignParams.apiUrl + '/giftvalidate'
const GIFTCONFIRM = cashbackCampaignParams.apiUrl + '/giftconfirm'
const GIFTCHARGEBACK = cashbackCampaignParams.apiUrl + '/giftchargeback'
const CASHBACK_PROGRAMS = cashbackCampaignParams.apiUrl + '/cashback-programs'
const ORDERS = cashbackCampaignParams.apiUrl + '/orders'
const CLIENT_INFO = cashbackCampaignParams.apiUrl + '/clientinfo'

const generalInfo = Util.getGeneralInfo() || {}

let clientInfo = {}
let casbackProgramsData = null
let giftsQrcodeData = null
let validGiftData = null
let giftsApplied = []
let couponsAvailable = []
let cashbackValue = 0
/*
    @temporary_code: Recebe o código temporário (Com expiração de 10 minutos)
    que o cliente coleta da sua wallet e informa. Com o código temporário recebe os dados sobre o cupom
*/

/* campanha de cashback olga */
const checkStatus = async function () {
    if (!cashbackCampaignParams.apiUrl) {
        return false
    }
    let hasAllParams = true
    Object.keys(apiHeaders).forEach(e => {
        if (!apiHeaders[e]) hasAllParams = false // verifica se todos os itens do header estão presentes
    })
    if (!hasAllParams) {
        return false
    }
    let apiStatus = await requestModule.externalRequest(cashbackCampaignParams.apiUrl, apiHeaders, {}, 'get')
        .then((r) => r)
        .catch((e) => {
            console.log('Falha ao consultar o endereço da API campanha de cashback')
            return false
        })
    if (!apiStatus || !apiStatus.version) {
        return false
    }
    return true
}

const getClientInfo = async function (phone) {
    if (!cashbackCampaignParams.apiUrl) {
        return false
    }
    const params = {
        root: {
            subsidiaryCode: generalInfo.subsidiaryCode,
            customer_phone: phone.replace('+', ''),
            customer_doc: ''
        }
    }
    let result = await requestModule.xmlRequest(CLIENT_INFO, 'post', params, apiHeaders)
    if (!result || result.error) {
        return false
    }
    result = formatResult(result)
    clientInfo = (result && result.root && result.root.response && result.root.response.data) || {}
    clientInfo = formatResult(clientInfo) || {}
    if (clientInfo && clientInfo.benefits && clientInfo.benefits.coupons) {
        couponsAvailable = filterCoupons(clientInfo.benefits.coupons.data)
    }

    return clientInfo
}

const getCashbackPrograms = async function () {
    /*
        Responsável por retornar dados do programa de cashback atual.
        Caso o programa esteja desabilitado, nenhuma informação será retornada.
    */
    if (!cashbackCampaignParams.apiUrl) {
        return null
    }

    const params = {
        root: {
            subsidiaryCode: generalInfo.subsidiaryCode
        }
    }
    let result = await requestModule.xmlRequest(CASHBACK_PROGRAMS, 'post', params, apiHeaders)
    if (!result || (result && result.error)) {
        console.log('Error getCashbackPrograms', result)
        return null
    }
    result = formatResult(result)

    if (!result || !result.root || !result.root.data || result.root.data.status !== 'ENABLED') {
        casbackProgramsData = null
    } else {
        casbackProgramsData = result.root.data
    }
    return casbackProgramsData
}

const getGiftsQrcode = async function (giftCode, phone = '') {
    /*
        Responsável por buscar um cupom de desconto ou cashback na carteira do cliente.
    */
    if (!phone) {
        return false
    }
    const params = {
        root: {
            subsidiaryCode: generalInfo.subsidiaryCode,
            temporary_code: giftCode,
            phone: phone.replace('+', '')
        }
    }
    let result = await requestModule.xmlRequest(GIFTSQRCODE, 'post', params, apiHeaders)

    if (!isValidApiResponse(result) || !result.root.data.valid) {
        console.log('Falha na rotina getGiftsQrcode')
        return {
            error: true,
            message: 'Não foi possível encontrar o cupom. Tente novamente.'
        }
    }
    giftsQrcodeData = formatResult(result.root.data)
    validGiftData = await validateGift(giftsQrcodeData.data, phone)
    if (validGiftData.error) {
        return {
            error: true,
            message: validGiftData.message
        }
    }
    validGiftData = {...validGiftData, gift: giftsQrcodeData.data}
    return validGiftData
}

const validateGift = async function (giftsQrcodeData, phone) {
    /*
    Necessário para validar um cupom antes de aprovar uma venda. Cupons inválidos podem prejudicar a operação da venda.
    Observação: Quando o cupom for de uso de cashback (is_cashback==1) o campo gift_id deve ser preenchido com "null"
    */
    if (!phone) {
        return false
    }

    const params = {
        root: {
            subsidiaryCode: generalInfo.subsidiaryCode, // Código da filial
            customer_phone: phone, // Telefone do cliente
            gift_id: giftsQrcodeData.type === 'CASHBACK' ? null : (giftsQrcodeData.id || null), // Id do cupom (coupon_id). null quando uso de cashback
            order_amount: CartController.getTotalPriceAsFloat(false, false), // Valor do pedido sem desconto
            is_delivery: false, // É uma venda delivery?
            order_delivery_amount: 0.00 // Valor do frete
        }
    }
    let result = await requestModule.xmlRequest(GIFTVALIDADE, 'post', params, apiHeaders)
    result = formatResult(result)
    if (result && result.error) {
        return {
            error: true,
            message: result.message || 'Não foi possível validar o cupom. Tente novamente.'
        }
    }
    if (!isValidApiResponse(result, false) || !result.root.data.gift) {
        console.log('Falha na rotina validateGift')
        return {
            error: true,
            message: 'Não foi possível validar o cupom. Tente novamente.'
        }
    }
    return formatResult(result.root.data.gift)
}

const confirmGift = async function (phone, saleData, discount) {
    /*
        Para o cupom ser removido da carteira do cliente é necessário aplicar a confirmação de uso do cupom
        Observação: Quando o cupom for de uso de cashback (is_cashback==1) o campo gift_id deve ser preenchido com "null"
    */
    if (!phone) {
        return false
    }
    if (!giftsApplied || giftsApplied.length === 0) {
        return false
    }

    let giftAppliedType = giftsApplied[0].type

    const params = {
        root: {
            subsidiaryCode: generalInfo.subsidiaryCode,
            customer_phone: phone, // Telefone do cliente
            gift_id: (giftsApplied && giftsApplied[0]) && (giftsApplied[0].is_cashback === true || giftsApplied[0].is_cashback === 'true') ? null : giftsApplied[0].gift.coupon_id, // Id do cupom (coupon_id). null quando uso de cashback
            reference_id: saleData.saleSeq, // Identificação única da venda
            order_amount: CartController.getTotalPriceAsFloat(false, false), // Valor do pedido sem desconto
            is_delivery: false, // É uma venda delivery?
            order_delivery_amount: 0.00, // Valor do frete
            order_discount: (giftsApplied[0] && giftsApplied[0].amount && giftAppliedType !== 'CASHBACK_ACCUMULATE') ? discount : 0.00 // Valor em reais do desconto dado pelo cupom
        }
    }
    let result = await requestModule.xmlRequest(GIFTCONFIRM, 'post', params, apiHeaders)
    result = formatResult(result)
    if (!isValidApiResponse(result, false)) {
        console.log('Falha na rotina confirmGift')
        Util.showInfoModal((result.message || '') + 'Falha ao aplicar o cupom de desconto. <br> A venda será cancelada.')
        throw new Error('Falha na rotina confirmGift')
    }
    return result.root.data
}

const chargebackGift = async function (phone, saleData) {
    /*
        Caso o cupom tenha sido confirmado é possível estornar o uso, o devolvendo para a carteira do cliente.
        Não esta sendo utilizado, pois a interface ja faz o estorno do cupom ao cancelar a venda.
    */
    if (!phone) {
        return false
    }
    if (!giftsApplied || giftsApplied.length === 0) {
        return false
    }
    const params = {
        root: {
            subsidiaryCode: generalInfo.subsidiaryCode,
            customer_phone: phone, // Telefone do cliente
            gift_id: (giftsApplied && giftsApplied[0]) && (giftsApplied[0].is_cashback === true || giftsApplied[0].is_cashback === 'true') ? null : giftsApplied[0].gift.coupon_id, // Id do cupom (coupon_id). null quando uso de cashback, // Id do cupom (coupon_id). null quando uso de cashback
            order_amount: CartController.getTotalPriceAsFloat(false, false), // Valor do pedido sem desconto
            is_delivery: false,
            order_delivery_amount: 0.00, // Valor do frete
            reference_id: saleData.saleSeq // Identificação única da venda
        }
    }
    const result = await requestModule.xmlRequest(GIFTCHARGEBACK, 'post', params, apiHeaders)
    if (!isValidApiResponse(result)) {
        console.log('Falha na rotina chargebackGift')
        return null
    }
    return result.root.data
}

// validar com combo do combo
function buildProducts () {
    let products = []
    let prod = []
    let cart = CartController.getCart() || []
    // a função price update coloca o price 0 em todos os produtos no carrinho
    // que não alteram o preço, nesse caso percorre o carrinho e adiciona no products
    // somente quem tem preço diferente de 0

    cart.forEach((e) => {
        if (e.price !== 0) {
            let item = {
                name: e.productName,
                code_integration: e.productCode,
                size_name: '',
                size_code_integration: '',
                category_name: '',
                category_code_integration: '',
                quantity: e.quantity || 1,
                total: e.price
            }
            prod.push(item)
        }
        e.observations.forEach((obs) => {
            if (obs.price !== 0) {
                let item = {
                    name: obs.obsName,
                    code_integration: obs.obsProductCode,
                    size_name: '',
                    size_code_integration: '',
                    category_name: '',
                    category_code_integration: '',
                    quantity: 1,
                    total: obs.price
                }
                prod.push(item)
            }
        })
        e.productCombo.forEach((c) => {
            if (c.price !== 0) {
                let item = {
                    name: c.subItemName,
                    code_integration: c.subItemCode,
                    size_name: '',
                    size_code_integration: '',
                    category_name: '',
                    category_code_integration: '',
                    quantity: c.quantity || 1,
                    total: c.price
                }
                prod.push(item)
            }
            if (c.observations && c.observations.length) {
                c.observations.forEach((cObs) => {
                    if (cObs.price !== 0) {
                        let item = {
                            name: cObs.subItemObsName,
                            code_integration: cObs.subItemObsProductCode,
                            size_name: '',
                            size_code_integration: '',
                            category_name: '',
                            category_code_integration: '',
                            quantity: c.quantity || 1,
                            total: cObs.price
                        }
                        prod.push(item)
                    }
                })
            }
            if (c.choosen) {
                Object.keys(c.choosen).forEach((key) => {
                    c.choosen[key].forEach((cc) => {
                        if (cc.price !== 0) {
                            let item = {
                                name: cc.subItemName,
                                code_integration: cc.subItemCode,
                                size_name: '',
                                size_code_integration: '',
                                category_name: '',
                                category_code_integration: '',
                                quantity: cc.quantity || 1,
                                total: cc.price
                            }
                            prod.push(item)
                        }
                        if (cc.observations && cc.observations.length) {
                            cc.observations.forEach((ccObs) => {
                                if (ccObs.price !== 0) {
                                    let item = {
                                        name: ccObs.subItemObsName,
                                        code_integration: ccObs.subItemObsProductCode,
                                        size_name: '',
                                        size_code_integration: '',
                                        category_name: '',
                                        category_code_integration: '',
                                        quantity: cc.quantity || 1,
                                        total: ccObs.price
                                    }
                                    prod.push(item)
                                }
                            })
                        }
                    })
                })
            }
        })
    })
    products = [{
        'data': prod
    }]
    return products
}

function buildDiscounts () {
    if (giftsApplied && giftsApplied.length > 0) {
        return {
            type: (giftsApplied[0] && giftsApplied[0].is_cashback === 'true') || (giftsApplied[0] && giftsApplied[0].is_cashback === true) ? 'OLGA_CASHBACK' : 'OLGA_GIFT', // OLGA_CASHBACK quando uso de cashback OLGA_GIFT quando cupom de desconto
            total: (giftsApplied[0] && giftsApplied[0].amount && giftsApplied[0].type !== 'CASHBACK_ACCUMULATE') ? parseFloat(giftsApplied[0].amount) : 0.00 // Valor do desconto em reais Float
        }
    }
    return {
        type: '', // OLGA_CASHBACK quando uso de cashback OLGA_GIFT quando cupom de desconto
        total: 0 // Valor do desconto em reais Float
    }
}

function filterCoupons (coupons) {
    if (!coupons) {
        return []
    }
    coupons = formatResult(coupons)
    return coupons.filter((coupon) => {
        return coupon.enabled && (coupon.enabled === 'true' || coupon.enabled === true)
    })
}

const orderGift = async function (phone) {
    /*
        Responsável pelo recebimento dos pedidos feitos no restaurante. Pode conter, opcionalmente, os dados dos clientes do pedido também.
    */
    const params = {
        root: {
            subsidiaryCode: generalInfo.subsidiaryCode,
            data: {
                total: CartController.getTotalPriceAsFloat(false, false), // Total do pedido em reais
                customer: { // Cliente que fez o pedido
                    code_integration: '', // Identificador único do cliente na fonte de dados
                    name: clientInfo.name || '', // Nome completo
                    phone: phone, // Telefone
                    email: clientInfo.email || '', // Email
                    doc: clientInfo.doc || (giftsApplied && giftsApplied[0] && giftsApplied[0].gift.customer_doc) || '', // CPF
                    birthdate: clientInfo.birthdate || '', // Data de nascimento
                    created_at: '', // Data de criação
                    consent: true // Consentimento de LGPD
                },
                items: buildProducts(),
                discounts: buildDiscounts(),
                note: '', // Observação do pedido
                created_at: moment().format('YYYY-MM-DD HH:mm') // Data de criação do pedido
            }
        }
    }
    let result = await requestModule.xmlRequest(ORDERS, 'post', params, apiHeaders)
    if (!result || (result && result.error)) {
        console.log('Falha na rotina orderGift')
        Util.showInfoModal((result.message || '') + 'Falha ao gerar cashback. <br> A venda será cancelada.')
        throw new Error('Falha na rotina orderGift')
    }
    result = formatResult(result)
    if (!isValidApiResponse(result)) {
        console.log('Falha na rotina orderGift')
        Util.showInfoModal((result.message || '') + 'Falha ao gerar cashback. <br> A venda será cancelada.')
        throw new Error('Falha na rotina orderGift')
    }
    return result.root.data
}

const removeGiftApplied = function (index) {
    giftsApplied.splice(index, 1)
}

function formatResult (result) {
    if (!result) {
        return null
    }
    try {
        return Util.flattenXmlTextFields(result)
    } catch (error) {
        console.log('Error formatting result', error)
        return null
    }
}

/**
 * Valida se o retorno da API é válido
 * @param {Object} result - Objeto de resultado da API
 * @param {boolean} hasResponse - Se true, verifica result.root.response.data, senão verifica result.root.data
 * @returns {boolean} - Retorna true se o resultado é válido, false caso contrário
 */
function isValidApiResponse (result, hasResponse = false) {
    if (!result || (result && (result.error || result.errors))) {
        console.log('Invalid API response', result)
        return false
    }

    if (!result.root) {
        console.log('Invalid API response', result)
        return false
    }

    // Valida propriedade code se existir - deve ser '200' para ser válido
    if (result.root.code) {
        const codeValue = result.root.code._text || result.root.code
        if (codeValue !== '200') {
            console.log('Invalid API response', result)
            return false
        }
    }

    if (hasResponse) {
        // Valida estrutura com response: result.root.response.data
        if (result.root.response && result.root.response.code) {
            const codeValue = result.root.response.code._text || result.root.response.code
            if (codeValue !== '200') {
                console.log('Invalid API response', result)
                return false
            }
        }
        return !!(result.root.response && result.root.response.data)
    } else {
        return !!result.root.data
    }
}

const setGiftApplied = function (gift) {
    giftsApplied.push(gift)
}

const getGiftApplied = function () {
    return giftsApplied
}

const getCouponsAvailable = function () {
    return couponsAvailable
}

export default {
    checkStatus,
    getGiftsQrcode,
    validateGift,
    confirmGift,
    chargebackGift,
    orderGift,
    getCashbackPrograms,
    clearData: () => {
        giftsQrcodeData = null
        validGiftData = null
        giftsApplied = []
        cashbackValue = 0
        couponsAvailable = []
        clientInfo = {}
    },
    setGiftApplied,
    getGiftApplied,
    removeGiftApplied,
    getClientInfo,
    getCouponsAvailable,
    getClientData: () => {
        return clientInfo
    },
    getCashbackValue: () => {
        return cashbackValue
    },
    setCashbackValue: (value) => {
        cashbackValue = value
    },
    getResume: () => {
        return {
            campaignEnabled: 4,
            cashbackValue: cashbackValue
        }
    }
}



// WEBPACK FOOTER //
// ./src/assets/controllers/CampaignFidelityOlgaController.js